import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import ReportView from "@/components/ReportView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReportPage() {
  const { auditId } = useParams();
  const navigate = useNavigate();
  const [audit, setAudit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAudit();
  }, [auditId]);

  const loadAudit = async () => {
    try {
      const res = await axios.get(`${API}/audits/${auditId}`);
      if (!res.data.report) {
        setError("Report not generated yet.");
      } else {
        setAudit(res.data);
      }
    } catch (err) {
      setError("Audit not found.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center" data-testid="report-loading">
        <Loader2 className="h-8 w-8 text-[#DC0706] animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6" data-testid="report-error">
        <div className="text-center">
          <p className="font-['Albert_Sans'] text-[#A1A1AA] text-lg mb-6">{error}</p>
          <button
            data-testid="back-home-btn"
            onClick={() => navigate("/")}
            className="font-['Bruno_Ace_SC'] text-sm uppercase tracking-[0.2em] text-[#DC0706] hover:text-[#FE4D00] transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return <ReportView audit={audit} />;
}
